const PERMISSIONS = {
  VIEW_ACCOUNT: 'view_account',
  ADD_PRIVATE_CAMPAIGN_FLAG: 'add_private_campaign_flag',
  CHANGE_PRIVATE_CAMPAIGN_FLAG: 'change_private_campaign_flag',
  ADD_AGENCY: 'add_agency',
  CHANGE_AGENCY: 'change_agency',
  DELETE_AGENCY: 'delete_agency',
  VIEW_AGENCY: 'view_agency',
  ADD_ROLE: 'add_role',
  CHANGE_ROLE: 'change_role',
  DELETE_ROLE: 'delete_role',
  VIEW_ROLE: 'view_role',
  ADD_USER: 'add_user',
  CHANGE_USER: 'change_user',
  DELETE_USER: 'delete_user',
  IMPORT_USERS: 'import_users',
  VIEW_PROFILE: 'view_profile',
  VIEW_USER: 'view_user',
  ADD_ASSIGNMENT: 'add_assignment',
  CHANGE_ASSIGNMENT: 'change_assignment',
  DELETE_ASSIGNMENT: 'delete_assignment',
  VIEW_ASSIGNMENT: 'view_assignment',
  ADD_CAMPAIGN: 'add_campaign',
  VIEW_AUDIT_LOG: 'view_auditlog',
  CHANGE_CAMPAIGN: 'change_campaign',
  DELETE_CAMPAIGN: 'delete_campaign',
  VIEW_CAMPAIGN: 'view_campaign',
  ADD_VISIT: 'add_visit',
  ALLOW_ANY_VISIT: 'allow_any_visit',
  CHANGE_VISIT: 'change_visit',
  DELETE_VISIT: 'delete_visit',
  IMPORT_VISIT: 'import_visit',
  VIEW_VISIT: 'view_visit',
  VIEW_ENFORCEMENT_VISITS: 'view_enforcement_visits',
  VIEW_EDUCATION_VISITS: 'view_education_visits',
  VIEW_ASSESSMENT_VISITS: 'view_assessment_visits',
  VIEW_MAPS: 'view_maps',
  USE_ADVANCED_SEARCH: 'use_advanced_search',
  // P20M-968 — "Unable to complete visit" button, one per visit type (form_type).
  // Set per role in the App Dashboard's Other Permissions matrix.
  USE_UNABLE_TO_COMPLETE_ASSESSMENT: 'use_unable_to_complete_assessment',
  USE_UNABLE_TO_COMPLETE_EDUCATION: 'use_unable_to_complete_education',
  USE_UNABLE_TO_COMPLETE_ENFORCEMENT: 'use_unable_to_complete_enforcement',
  USE_NEW_UI_2026_06: 'use_new_ui_2026_06',
  // App Dashboard section access (P20M-1309). The App Dashboard is
  // superuser-only by default; a non-superuser staff member sees only the
  // section(s) they hold a permission for.
  VIEW_ACCOUNT_STATISTIC: 'view_account_statistic',
  VIEW_TENANTS_MANAGEMENT: 'view_tenants_management',
  VIEW_STAFF_MANAGEMENT: 'view_staff_management',
  VIEW_MERGER_TUNING: 'view_merger_tuning',
  // opens ONLY the GovRAMP certifications page (P20M-1327, for DevOps)
  VIEW_GOVRAMP: 'view_govramp',
  ADD_VENUE: 'add_venue',
  CHANGE_VENUE: 'change_venue',
  DELETE_VENUE: 'delete_venue',
  VIEW_VENUE: 'view_venue',
  ADD_RETAILER: 'add_retailer',
  CHANGE_RETAILER: 'change_retailer',
  DELETE_RETAILER: 'delete_retailer',
  IMPORT_RETAILER: 'import_retailer',
  IMPORT_RETAILERS: 'import_retailers',
  VIEW_SIMILARSTORES: 'view_similarstores',
  VIEW_SIMILARSTORES_MATCHING_RULE: 'view_similarstores_matching_rule',
  MERGE_RETAILER: 'merge_retailer',
  VIEW_RETAILER: 'view_retailer',
  VIEW_RETAILER_SIMILAR_STORES: 'view_retailer_similar_stores',
  VIEW_RETAILER_MEDIA: 'view_retailer_media',
  // Account module (arrives in modularity_permissions) — turns the media tabs on at all. Required
  // TOGETHER with the VIEW_RETAILER_MEDIA role permission; see modules/Media/useMediaAccess.
  MEDIA_DOCS: 'media_docs',
  // Account module (arrives in modularity_permissions) — turns the whole media tagging feature on.
  MEDIA_TAGS: 'media_tags',
  // Role permission — create/rename/delete the tag vocabulary (does NOT imply assigning).
  MANAGE_MEDIA_TAGS: 'manage_media_tags',
  // Role permission — apply/remove EXISTING tags on media without vocabulary writes.
  ASSIGN_MEDIA_TAGS: 'assign_media_tags',
  // Account module (arrives in modularity_permissions) — turns retailer notes on at all. Required
  // TOGETHER with the VIEW_RETAILERNOTE role permission (P20M-1242).
  RETAILER_NOTES: 'retailer_notes',
  VIEW_RETAILERNOTE: 'view_retailernote',
  ADD_RETAILERNOTE: 'add_retailernote',
  CHANGE_RETAILERNOTE: 'change_retailernote',
  DELETE_RETAILERNOTE: 'delete_retailernote',
  ADD_FORM: 'add_form',
  CHANGE_FORM: 'change_form',
  DELETE_FORM: 'delete_form',
  VIEW_FORM: 'view_form',
  VIEW_YOUTH: 'view_youth',
  ADD_YOUTH: 'add_youth',
  CAN_ACCESS_STAFF_SUPERUSER_INFO: 'can_access_staff_superuser_info',
  VIEW_REVISIT_TABLE: 'view_revisit_table',
  VIEW_USER_FILTER: 'view_user_filter',
  MA_VIEW_OTHER_VIOLATION_INFO: 'ma_view_other_violation_info',
  VIEW_OTHER_VIOLATION_INFO: 'view_other_violation_info',
  CHANGE_YOUTH: 'change_youth',
  DELETE_YOUTH: 'delete_youth',
  IMPORT_YOUTH: 'import_youth',
  VIEW_FORM_YOUTH_DROPDOWN: 'view_form_youth_dropdown',
  VIEW_YOUTH_LINK: 'view_youth_link',
  VIEW_REPORTS: 'view_reports',
  VIEW_SNAPSHOT_MAPS: 'view_snapshot_maps',
  ADD_VISIT_VIOLATION_INFO: 'add_visitviolationinfo',
  CHANGE_VISIT_VIOLATION_INFO: 'change_visitviolationinfo',
  DELETE_VISIT_VIOLATION_INFO: 'delete_visitviolationinfo',
  VIEW_VISIT_VIOLATION_INFO: 'view_visitviolationinfo',
  CAN_SEND_PASSWORD_RESET_EMAIL: 'can_send_password_reset_email',
  DISPARATE_BURDEN_VIEW: 'view_infographic_disparateburden',
  VIEW_ENFOCEMENT_OVERVIEW: 'view_infographic_enforcementoverview',
  VIEW_POST_LANDSCAPE: 'view_infographic_poslandscape',
  VIEW_RETAILER_REDUCTION: 'view_infographic_retailerreduction',
  VIEW_YOUTH_APPEAL: 'view_infographic_youthappeal',
  VIEW_SUMMARY_REPORT_AREA: 'view_report_area_summary_report',
  VIEW_REPORT_ENFORCEMENT_OVERVIEW: 'view_report_enforcement_overview_report',
  VIEW_REPORT_EDUCATION_OVERVIEW: 'view_report_education_overview_report',
  VIEW_SNAPSHOT_DENSITY: 'view_snapshot_map_density',
  VIEW_SNAPSHOT_POLICY: 'view_snapshot_map_policy',
  VIEW_SNAPSHOT_SCHOOLS: 'view_snapshot_map_schools',
  VIEW_SNAPSHOT_AVAILABILITY: 'view_snapshot_map_availability',
  VIEW_SNAPSHOT_PROMOTION: 'view_snapshot_map_promotion',
  VIEW_SNAPSHOT_PRICE: 'view_snapshot_map_price',
  VIEW_SNAPSHOT_EDUCATION: 'view_snapshot_map_education',
  VIEW_SNAPSHOT_ENFORCEMENT: 'view_snapshot_map_enforcement',
  VIEW_SNAPSHOTS: 'views_snapshots',
  VIEW_STORIES: 'view_stories',
  RESIDENTIAL_LOCATION: 'view_residential_address',
  VIEW_NEAR_SCHOOL: 'view_near_school',
  VIEW_NEAR_RETAILER: 'view_near_retailer',
  VIEW_DRIVING_DIRECTIONS: 'view_driving_directions',
  VIEW_COUNTY_COURTS_LIST: 'view_court',
  CHANGE_ATCC: 'change_atcc',
  ADDING_RETAILERS_TO_CAMPAIGN: 'adding_retailers_to_campaign',
  LOGIN_AS_USER: 'login_as_user',
  SHOW_NEW_REPORTS: 'show_new_reports',
  SYNAR_CAMPAIGN: 'synar_campaign',
  // P20M-1338 — state-dependent Synar capabilities derived by the backend:
  // SYNAR_CAMPAIGN_TYPE (AZ campaign-mode only) gates the campaign side,
  // SYNAR_RETAILER_FIELD (the "Synar year field" account module) gates the
  // retailer Synar-year field/filters. Do not gate UI on SYNAR_CAMPAIGN —
  // it only means the account module is on, regardless of state.
  SYNAR_CAMPAIGN_TYPE: 'synar_campaign_type',
  SYNAR_RETAILER_FIELD: 'synar_retailer_field',
  CHANGE_SYNAR_YEAR: 'change_synar_year',
  SYNAR_CLASTER_SAMPLE: 'synar_cluster_sample',
  // P20M-1388 — MA Synar Inspection Report card/page (Agency Manager+ of MA)
  VIEW_SYNAR_INSPECTION_REPORT: 'view_synar_inspection_report',
  CHANGE_CONTROL_NUMBER: 'change_control_number',
  // P20M-1308 — filter visibility. Most query-builder filter groups are hidden from all users in all
  // accounts. VIEW_ALL_HIDDEN_FILTERS is the single master override (assigned to Multi-Account
  // Managers) that reveals every hidden group on every page. Each per-group permission below can
  // selectively reveal just that group in the future.
  //
  // The same filter group (e.g. Products sold, Store ownership, Other retailer details) is rendered
  // on more than one page type, and the ticket requires hiding it per page. So the permissions are
  // scoped per page: the Retailer-list group permissions keep their original (page-less) names, and
  // the Education / Enforcement / Assessment visit lists each get their own view_filter_<page>_<group>
  // permission. AVC agreement filters are NOT covered by any of these — they are gated purely on the
  // AZ/FL subdomain (see IsAzAccount / IsFlAccount).
  VIEW_ALL_HIDDEN_FILTERS: 'view_all_hidden_filters',

  // Retailer list (original page-less names, retained).
  VIEW_FILTER_PRODUCTS_SOLD_TOBACCO: 'view_filter_products_sold_tobacco',
  VIEW_FILTER_PRODUCTS_SOLD_ALCOHOL: 'view_filter_products_sold_alcohol',
  VIEW_FILTER_STORE_TYPE: 'view_filter_store_type',
  VIEW_FILTER_STORE_OWNERSHIP: 'view_filter_store_ownership',
  VIEW_FILTER_OTHER_RETAILER_DETAILS: 'view_filter_other_retailer_details',
  VIEW_FILTER_ADVANCED: 'view_filter_advanced',

  // Education visit list.
  VIEW_FILTER_EDUCATION_VISIT_COMPLETION_STATUS: 'view_filter_education_visit_completion_status',
  VIEW_FILTER_EDUCATION_COMPLIANCE_INSPECTION: 'view_filter_education_compliance_inspection',
  VIEW_FILTER_EDUCATION_DISCUSSION: 'view_filter_education_discussion',
  VIEW_FILTER_EDUCATION_PRODUCTS_SOLD_TOBACCO: 'view_filter_education_products_sold_tobacco',
  VIEW_FILTER_EDUCATION_PRODUCTS_SOLD_ALCOHOL: 'view_filter_education_products_sold_alcohol',
  VIEW_FILTER_EDUCATION_STORE_OWNERSHIP: 'view_filter_education_store_ownership',
  VIEW_FILTER_EDUCATION_OTHER_RETAILER_DETAILS: 'view_filter_education_other_retailer_details',

  // Enforcement / inspection visit list.
  VIEW_FILTER_ENFORCEMENT_VISIT_COMPLETION_STATUS: 'view_filter_enforcement_visit_completion_status',
  VIEW_FILTER_ENFORCEMENT_AGE_VERIFICATION: 'view_filter_enforcement_age_verification',
  VIEW_FILTER_ENFORCEMENT_OTHER_VISIT_DETAILS: 'view_filter_enforcement_other_visit_details',
  VIEW_FILTER_ENFORCEMENT_PRODUCTS_SOLD_TOBACCO: 'view_filter_enforcement_products_sold_tobacco',
  VIEW_FILTER_ENFORCEMENT_PRODUCTS_SOLD_ALCOHOL: 'view_filter_enforcement_products_sold_alcohol',
  VIEW_FILTER_ENFORCEMENT_STORE_OWNERSHIP: 'view_filter_enforcement_store_ownership',
  VIEW_FILTER_ENFORCEMENT_OTHER_RETAILER_DETAILS: 'view_filter_enforcement_other_retailer_details',

  // Assessment visit list.
  VIEW_FILTER_ASSESSMENT_VISIT_COMPLETION_STATUS: 'view_filter_assessment_visit_completion_status',
  VIEW_FILTER_ASSESSMENT_RESULTS: 'view_filter_assessment_results',
  VIEW_FILTER_ASSESSMENT_PRODUCTS_SOLD_TOBACCO: 'view_filter_assessment_products_sold_tobacco',
  VIEW_FILTER_ASSESSMENT_PRODUCTS_SOLD_ALCOHOL: 'view_filter_assessment_products_sold_alcohol',
  VIEW_FILTER_ASSESSMENT_STORE_OWNERSHIP: 'view_filter_assessment_store_ownership',
  VIEW_FILTER_ASSESSMENT_OTHER_RETAILER_DETAILS: 'view_filter_assessment_other_retailer_details',
  // Injected by the backend only for superusers; used to gate edit controls on
  // the dashboard matrices and the superuser-only Staff Management section.
  EDIT_FILTER_MATRIX: 'edit_filter_matrix',
};

// App Dashboard section permissions (P20M-1309 / P20M-1327). Superusers always
// pass; a non-superuser needs at least one of these to reach the App Dashboard
// at all. Single source of truth for the route guard, the menu link and the
// auth selectors — a section added here is admitted everywhere at once.
export const APP_DASHBOARD_SECTION_PERMISSIONS = [
  PERMISSIONS.VIEW_ACCOUNT_STATISTIC,
  PERMISSIONS.VIEW_TENANTS_MANAGEMENT,
  PERMISSIONS.VIEW_STAFF_MANAGEMENT,
  PERMISSIONS.VIEW_MERGER_TUNING,
  PERMISSIONS.VIEW_GOVRAMP,
];

// Baseline grants every role carries (the backend gates /api/profile on
// view_profile). They open no tenant page, so "has the user any tenant
// permission?" checks must skip them.
export const BASELINE_PERMISSIONS = [PERMISSIONS.VIEW_PROFILE, PERMISSIONS.VIEW_ACCOUNT];

export default PERMISSIONS;
